(() => {
  const init = (scope = document) => scope.querySelectorAll('[data-box-gallery]').forEach((gallery) => {
    if (gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const buttons = [...gallery.querySelectorAll('[data-box-thumbnail]')];
    const show = (button) => {
      gallery.querySelectorAll('[data-box-photo]').forEach((photo) => { photo.hidden = photo.dataset.boxPhoto !== button.dataset.boxThumbnail; });
      buttons.forEach((other) => other.setAttribute('aria-pressed', String(other === button)));
    };
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => show(button));
      button.addEventListener('keydown', (event) => {
        const shifts = {ArrowLeft: -1, ArrowRight: 1};
        if (!(event.key in shifts)) return;
        event.preventDefault();
        const next = buttons[(index + shifts[event.key] + buttons.length) % buttons.length];
        show(next); next.focus();
      });
    });
  });
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

// Move the existing nodes on breakpoint changes so keyboard order matches visual order.
(() => {
 const originalOrders = new WeakMap();
 const media = window.matchMedia ? window.matchMedia('(max-width: 749px)') : {matches:false};
 function items(group) {
  return [...group.children].map(node=>({node,settings:node.matches('[data-box-editable]')?node:node.querySelector(':scope > [data-box-editable]')})).filter(item=>item.settings);
 }
 function reorder(group) {
  const current=items(group);
  let original=originalOrders.get(group);
  if(!original){original=current.map(item=>item.node);originalOrders.set(group,original);}
  current.forEach(({node})=>{if(!original.includes(node))original.push(node);});
  const ranked=current.map(item=>{
   const d=Number(item.settings.dataset.desktopOrder)||((original.indexOf(item.node)+1)*10);
   return {...item,rank:media.matches?(Number(item.settings.dataset.mobileOrder)||d):d};
  }).sort((a,b)=>a.rank-b.rank||original.indexOf(a.node)-original.indexOf(b.node));
  if(ranked.some((item,i)=>item.node!==current[i]?.node))ranked.forEach(item=>group.append(item.node));
 }
 function refresh() {
  document.querySelectorAll('.d2-box-builder,[data-box-sort-group]').forEach(reorder);
  document.querySelectorAll('.d2-box-builder .d2-box-nav a').forEach(link=>{
   const target=document.getElementById(link.hash.slice(1));
   link.hidden=!target||getComputedStyle(target).display==='none';
  });
 }
 media.addEventListener?.('change',refresh);
 document.addEventListener('DOMContentLoaded',refresh);
 document.addEventListener('shopify:section:load',refresh);
 document.addEventListener('shopify:section:reorder',()=>{document.querySelectorAll('.d2-box-builder').forEach(group=>originalOrders.delete(group));refresh();});
 document.addEventListener('shopify:block:select',event=>{
  const block=event.target.closest?.('.d2-box-editable-block') || event.target;
  const details=block.matches?.('details')?block:block.querySelector?.('details');
  if(details)details.open=true;
 });
})();
